(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/views/confirm.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/views/confirm.js'); "use strict";


(function (svs, $, gsap) {
  'use strict';

  svs.components.dialog = svs.components.dialog || {};

  class DialogConfirm extends svs.components.dialog.PubSub {
    constructor(options) {
      super(options);
      this.log = new svs.core.log.Logger('DialogConfirm');

      if (options.type === svs.components.dialog.type.ERROR) {
        options.branding = svs.components.dialog.branding.ERROR; 

        options.icon = 'exclamation-sign';
      }

      if (!options.branding) {
        throw new Error('This component must have a branding specified.');
      }

      const defaults = {
        branding: options.branding,
        title: options.title,
        icon: 'checkmark',
        autoClose: 0,
        convertToPopup: true,
        area: svs.components.dialog.area.POPUP,
        type: svs.components.dialog.type.CONFIRM,
        requireHandshake: false,
        handshakeTimeout: svs.components.dialog.handshakeTimeout.DEFAULT,
        _ContentClass: svs.components.dialog.Content
      };
      this.options = $.extend(defaults, options);
      this.currentHeight = undefined;
      this.requireHandshake = this.options.requireHandshake;
      this.handshakeFailsafe = undefined;
      this.handshakeTimeout = this.options.handshakeTimeout;
      this._isClosing = false;
      this._id = new Date().getTime();
      this.tl = {};
      this.render();
      this.setupAnimations();
    }

    hasRevealed() {
      this.log.debug("Dialog ".concat(this.options.title, " has revealed"));

      if (this.options.autoClose && this.type !== svs.components.dialog.type.ERROR) {
        this.timeout = setTimeout(() => {
          this.close();
        }, this.options.autoClose);
      } else {
        clearTimeout(this.timeout);
      }

      this.emit('revealed');

      this._buttons.setFocus();

      if (this.requireHandshake) {
        this.handshakeFailsafe = setTimeout(() => {
          this.requireHandshake = false;
          this.log.debug('Handshake timed out.');
        }, this.handshakeTimeout);
      }
    }

    setupAnimations() {
      this.tl = gsap.timeline({
        paused: true,
        onComplete: () => {
          this.hasRevealed();
        },
        onReverseComplete: () => {
          this.hasClosed();

          if (typeof this.onCloseCallback === 'function') {
            setTimeout(() => {
              this.onCloseCallback();
            }, 300);
          }
        }
      });
      this.tl.fromTo(this._content.el, {
        y: -10,
        autoAlpha: 0
      }, {
        duration: 0.15,
        y: 0,
        autoAlpha: 1
      });
      this.tl.fromTo(this._buttons.el, {
        opacity: 0,
        y: 50
      }, {
        duration: 0.15,
        opacity: 1,
        y: 0
      }, '-=.1');
    }

    next() {
      this.log.debug('Open next confirm');
      this.tl.seek(0);
      this.tl.play().timeScale(2);
    }

    close(callback) {
      this._isClosing = true;

      if (callback) {
        this.onCloseCallback = callback;
      } 


      clearTimeout(this.timeout);
      clearTimeout(this.handshakeFailsafe); 

      if (this.options.area === svs.components.dialog.area.TOASTER) {
        this.hasClosed();
      } else {
        this.tl.timeScale(2).reverse();
      }
    }

    reveal() {
      if (this.options.area === svs.components.dialog.area.TOASTER) {
        this.tl.seek(this.tl.duration(), true);
      }

      this.tl.play();
    }

    setDimensions() {
      this.height = this.el.offsetHeight;
      this.width = this.el.offsetWidth;
    }

    hide() {
      this.el.setAttribute('style', 'display: none');
    }

    hasClosed() {
      this.log.debug('Dialog has closed');

      if (!this.requireHandshake) {
        this.emit('closed');
      }
    }

    closed() {
      this.emit('hasClosed', {});
    }

    setScrollableHeight(h) {
      if (this.currentHeight !== h) {
        if (typeof h === 'string') {
          this.el.setAttribute('style', 'height: auto;');
        } else {
          this.el.setAttribute('style', "height: ".concat(h, "px;"));
        }

        this.currentHeight = h;

        this._content.testScrollArea();
      }
    }

    setAllowDimmerClick() {
      this.allowDimmerClick = true;

      if (this.options.area === svs.components.dialog.area.TOASTER || this.options.type === svs.components.dialog.type.ERROR || this.options.allowDimmerClick === false || this.options.actions && this.options.actions.length >= 2) {
        this.allowDimmerClick = false;
      }
    }

    resolveHandshake() {
      clearTimeout(this.handshakeFailsafe);
      this.requireHandshake = false;
      this.close();
    }

    getContent() {
      return new this.options._ContentClass(this.options);
    }

    createWrapper() {
      this.el = document.createElement('div');
      this.el.className += 'js-dialog-item dialog-item f-content';
      this.el.setAttribute('tabindex', '-1');
    }

    addButtons() {
      this._buttons = new svs.components.dialog.Buttons(this.options);

      this._buttons.on('close', this, () => {
        this.close();
      });

      this._buttons.on('callback', this, _ref => {
        let {
          e,
          callback
        } = _ref;
        callback(e, this.el.getElementsByClassName('js-dialog-item-checkbox'), this);
      });

      this._buttons.on('scrollToEnd', this, () => {
        this._content.scrollToEnd();
      });

      this.el.appendChild(this._buttons.el);
    }

    addContent() {
      this._content = this.getContent();
      this.el.appendChild(this._content.el);

      this._content.on('contentScrolling', this, () => {
        this._buttons.showScrollButton();
      });

      this._content.on('contentBottom', this, () => {
        this._buttons.hideScrollButton();
      });
    }

    render() {
      this.createWrapper();

      if (this.options.type === svs.components.dialog.type.ERROR) {
        this.el.className += ' dialog-item-error';
      }

      this.el.className += " dialog-branding-".concat(this.options.branding);
      this.addContent();
      this.addButtons();
      this.setAllowDimmerClick();
    }

  }

  svs.components.dialog.Confirm = DialogConfirm;
})(svs, $, gsap);
 })(window);